import { formValues } from 'redux-form';
import ProductChart from './ProductChart';

export default formValues({ contractType: 'data.contractType' })(ProductChart);
